@if (hasNoData) {
    {{ 'study-editor.summary-results.no-data' | translate}}
} @else {
    <div class="row pt-3">
        <div class="col d-flex justify-content-start align-items-center">
            <label>{{ 'study-editor.study-dataset.select-environment' | translate}}</label>
            <div class="col-3 ms-2">
                <ng-select [items]="environments" [ngModel]="selectedEnvironment" (ngModelChange)="onEnvironmentChange($event)" [clearable]="false">
                    <ng-template ng-label-tmp let-item="item">
                        @if (item.instanceNumber) {
                            {{ item.instanceNumber }} -
                        }
                        {{ item.locationName }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        @if (item.instanceNumber) {
                            {{ item.instanceNumber }} -
                        }
                        {{ item.locationName }}
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col-8 d-flex justify-content-start align-items-center">
            <label class="col-auto" jhiTranslate="global.records.per.page">Records per page:</label>
            <div class="col-2 ms-2">
                <select name="germplasm-table_length" class="form-select form-select-sm"
                        [(ngModel)]="pageSize"
                        (change)="onPageSizeChange($event)">
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
        <div class="col-4 d-flex justify-content-end align-items-center">
            <jhi-column-selector [showGroupToggle]="false"
                                 [displayedColumns]="displayedColumns"
                                 [columnDataService]="columnDataService"
                                 (reset)="onColumnSelectorReset()"></jhi-column-selector>
        </div>
    </div>
    <div class="container-fluid p-0">
        <div class="mt-3">
            <!-- Data Table -->
            <div class="table-responsive mt-3">
                <div class="custom-scroll-style" style="max-height: 500px; overflow-y: auto; overflow-x: auto;">
                    <table id="study-instances-table"
                           class="table table-striped table-bordered table-curved table-editable">
                        <thead class="sticky-header">
                        <tr>
                            @for (column of displayedColumns; track column.id) {
                                @if (column.selected && column.visible) {
                                    <th [ngClass]="getColumnClass(column)">

                                        {{ column.displayName || column.name }}

                                        @if (column.termId !== CHECKBOX && column.termId !== STATIC_COLUMN_FILES) {
                                            <span class="cursor-pointer ms-1"
                                                  #p="ngbPopover"
                                                  (click)="showColumnFilterPopover(column, p)"
                                                  [autoClose]="'outside'"
                                                  [ngbPopover]="columnFilterTemplate"
                                                  container="body"
                                                  [placement]="['bottom', 'right', 'auto']"
                                                  triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                                @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                    <i class="ps-1 fa fa-icon-active"
                                                       [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                                }
                                </span>
                                        }
                                    </th>
                                }
                            }
                        </tr>
                        </thead>
                        <tbody>
                            @if (items.length !== 0) {
                                @for (entry of items; track entry.observationUnitId; let row = $index) {
                                    <tr (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                        (mousedown)="preventDefaultOnShiftKey($event)"
                                        [class.selected]="isSelected(entry.observationUnitId)">
                                        @for (column of displayedColumns; track column.id; let col = $index) {
                                            @if (column.selected && column.visible && isCellDisabled(entry, column)) {
                                                <td class="disabled" disabled></td>
                                            } @else if (column.selected && column.visible) {
                                                <td *ngIf="column.selected" (click)="selectEditableCell(entry, row, col, $event)"
                                                    [class.selected]="editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)"
                                                    [ngClass]="getCellClass(entry, column, CategoricalMatchByEnum.NAME)"
                                                >
                                                    @switch (column.termId) {
                                                        @case (STATIC_COLUMN_ENTRY_TYPE) {
                                                            <span [title]="getCellValue(entry, column)">{{ getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView }}</span>
                                                        }
                                                        @case (STATIC_COLUMN_GID) {
                                                            @if (hasViewGermplasmDetailsPermission) {
                                                                <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)">{{ entry.gid }}</a>
                                                            } @else {
                                                                <span>{{ entry.gid }}</span>
                                                            }
                                                        }
                                                        @case (STATIC_COLUMN_DESIGNATION) {
                                                            @if (hasViewGermplasmDetailsPermission) {
                                                                <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                            } @else {
                                                                <truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                            }
                                                        }
                                                        @case (STATIC_COLUMN_FEMALE_PARENT_GID) {
                                                            @if (hasViewGermplasmDetailsPermission) {
                                                                <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.variables[column.name].value)">{{ entry.variables[column.name].value }}</a>
                                                            } @else {
                                                                <span>{{ entry.variables[column.name].value }}</span>
                                                            }

                                                        }
                                                        @case (STATIC_COLUMN_FEMALE_PARENT_NAME) {
                                                            @if (hasViewGermplasmDetailsPermission) {
                                                                <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.variables['FEMALE_PARENT_GID'].value)"><truncate-span [textInput]="entry.variables[column.name].value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                            } @else {
                                                                <truncate-span [textInput]="entry.variables[column.name].value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                            }

                                                        }
                                                        @case (STATIC_COLUMN_MALE_PARENT_GID) {
                                                            @if (entry.variables[column.name]?.values?.length > 1) {
                                                                @if (hasViewGermplasmDetailsPermission) {
                                                                    @for (value of entry.variables[column.name].values; track value) {
                                                                        <a href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(value)">{{ value }}</a>
                                                                    }
                                                                } @else {
                                                                    @for (value of entry.variables[column.name].values; track value) {
                                                                        <span>{{ value }}</span>
                                                                    }
                                                                }

                                                            } @else if (entry.variables[column.name]?.values?.length === 1 &&
                                                            entry.variables[column.name]?.values[0] !== 'UNKNOWN') {
                                                                @if (hasViewGermplasmDetailsPermission) {
                                                                    <a href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)">{{ entry.variables[column.name].values[0] }}</a>
                                                                } @else {
                                                                    <span>{{ entry.variables[column.name].values[0] }}</span>
                                                                }
                                                            } @else {
                                                                @if (entry.variables[column.name]?.values) {
                                                                    {{ entry.variables[column.name]?.values[0] || '' }}
                                                                }
                                                            }
                                                        }
                                                        @case (STATIC_COLUMN_MALE_PARENT_NAME) {
                                                            @if (entry.variables[column.name]?.values?.length > 1) {
                                                                @if (hasViewGermplasmDetailsPermission) {
                                                                    @for (value of entry.variables[column.name].values; track $index) {
                                                                        <a href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.variables['MALE_PARENT_GID'].values[$index])"><truncate-span [textInput]="value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                                    }
                                                                } @else {
                                                                    @for (value of entry.variables[column.name].values; track $index) {
                                                                        <truncate-span [textInput]="value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                                    }
                                                                }

                                                            } @else if (entry.variables[column.name]?.values?.length === 1 && entry.variables[column.name]?.values[0] !== 'UNKNOWN') {
                                                                @if (hasViewGermplasmDetailsPermission) {
                                                                    <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.variables['MALE_PARENT_GID'].values[0])">{{ entry.variables[column.name].values[0] }}</a>
                                                                } @else {
                                                                    <span>{{ entry.variables[column.name].values[0] }}</span>
                                                                }
                                                            } @else {
                                                                @if (entry.variables[column.name]?.values) {
                                                                    {{ entry.variables[column.name]?.values[0] || '' }}
                                                                }
                                                            }
                                                        }
                                                        @case (STATIC_COLUMN_OBS_UNIT_ID) {
                                                            <a  href="javascript:void(0)" (click)="$event.stopPropagation(); openObservationDetails(entry.variables[column.name].value)">{{ entry.variables[column.name].value }}</a>
                                                        }
                                                        @default {
                                                            @if (entry.variables[column.name]) {
                                                                <span>
                                                                {{ getCellValue(entry, column) | categoricalDisplayValue:column:'id':isCategoricalDescriptionView }}
                                                            </span>

                                                            }
                                                        }
                                                    }
                                                </td>
                                            }
                                        }
                                    </tr>
                                }
                            } @else {
                                <tr>
                                    <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                        {{ 'study-editor.no-records' | translate }}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">

                <div>
					@if (numberOfItems !== numberOfFilteredItems) {
						<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
							  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfFilteredItems}"></span>
						<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfItems}"></span>
					} @else {
						<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
							  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfItems}"></span>
					}
                </div>
                <div>
                    <div class="d-inline-block ms-3">
                        <ngb-pagination
                                [collectionSize]="numberOfFilteredItems || numberOfItems"
                                [(page)]="currentPage"
                                [pageSize]="pageSize"
                                [maxSize]="10"
                                [ellipses]="true"
                                [boundaryLinks]="true"
                                [rotate]="true"
                                (pageChange)="onPageChange($event)">
                        </ngb-pagination>
                    </div>
                    <div class="d-inline-block ms-3">
                        <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                        <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                               [min]="1" [max]="Math.ceil((numberOfFilteredItems || numberOfItems) / pageSize)"
                               [(ngModel)]="currentPage"
                               (change)="onPageChange(currentPage); $event.preventDefault()"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
}


<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        <!-- Regular Input Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

            <!-- Filter Options List -->
            <ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
                <li class="list-group-item" *ngIf="!columnDataForFilter.query">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="columnDataForFilter.isSelectAll"
                               (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
                        <label class="form-check-label" jhiTranslate="global.select.all.items">Select all</label>
                    </div>
                </li>
                <li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
                    class="list-group-item">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="option.isSelectedInFilters"
                               (change)="filterSelectOption(option.isSelectedInFilters)">
                        <label class="form-check-label">
                            {{ isCategoricalDescriptionView ? option.displayDescription : option.displayValue }}
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Date Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   ngbDatepicker="dp"
                   placeholder="{{ 'common.filter.value' | translate }}">
            <div class="mt-3">
                <ngb-datepicker #dp
                                [(ngModel)]="columnDataForFilter.query"
                                class="well well-sm"
                                (click)="$event.stopPropagation()">
                </ngb-datepicker>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
